import React from "react";
import { Box, Loader } from "@wix/design-system";

const Loading = ({ title = "", size = "", height = "" }) => {
  let loaderSize = size || "medium";
  let loaderHeight = height || "300px";

  return (
    <Box height={loaderHeight} verticalAlign="middle" align="center" padding="24px 0px" margin="0px 5px 0px 0px">
      <Loader size={loaderSize} text={title} />
    </Box>
  );
};

export default Loading;
